module.exports = __webpack_public_path__ + "img/Feature-2.f350194.svg";